import { environment } from './../../../../environments/environment.staging.exame';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentModel } from 'src/environments/environmentModel';
import { decodeInBrowserText } from 'tools/obfuscate';

@Injectable({ providedIn: 'root' })
export class ConfigService {
    public settings: EnvironmentModel;

    constructor(private http: HttpClient) { }    async loadConfig(): Promise<void> {
        const path = `assets/env/env.json`;
        try {
            const configEncoded = await this.http.get(path, { responseType: 'text' }).toPromise();
            const decodedString = decodeInBrowserText(configEncoded);
            this.settings = JSON.parse(decodedString) as EnvironmentModel;
        } catch (error) {
            console.error('❌ CONFIG: Erro ao carregar configurações:', error);
            console.warn('⚠️ CONFIG: Usando configurações padrão fallback');
            
            // Fallback - usar configurações básicas para evitar travamento
            this.settings = {
                clientName: 'btg',
                features: {
                    sso: { enabled: false, logoutUrl: '', logoutByClient: false },
                    showNotifications: true,
                    tutorialMenu: true,
                    cannotOpenProfile: false,
                    principlesConfiguration: false
                },
                hideReports: false
            } as any;
            
            console.log('✅ CONFIG: Fallback aplicado com sucesso');
        }
    }
}
